// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"3fbe0336","308":"0fd33074","517":"79c153ef","880":"94d0ebcc","888":"54f961e1","989":"516a7d2c"}[chunkId] + ".css";
};